<div class="block--content block">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <aside class="block__left-side-panel">
                <div class="text-items" *ngIf="!isNewDepartment">
                    <h1>
                        {{ 'EDIT_COMPANY_PROFILE' | translate }}
                    </h1>
                    <p class="text-items__description">
                        {{ 'DEPARTMENT_ACCOUNT_INFO' | translate }}
                    </p>
                </div>
                <div class="text-items" *ngIf="isNewDepartment">
                    <p class="text-items__title">
                        {{ 'ADD_DEPARTMENT_PROFILE' | translate }}
                    </p>
                    <p class="text-items__description">
                        {{ 'ADD_DEPARTMENT_ACCOUNT_INFO' | translate }}
                    </p>
                </div>
            </aside>

            <div class="block__right-side-panel">
                <div class="block-full-width no-padding no-border-radius">
                    <div class="edit-profile-account">
                        <div class="edit-profile-account-items-area">
                            <p class="edit-profile-account-items-area__title">
                                {{ 'DEPARTMENT_DETAILS' | translate }}
                            </p>

                            <form [formGroup]="departmentForm" (ngSubmit)="submitDepartment()">
                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="departmentForm.controls.name"
                                            ridangoInput
                                            name="department.name"
                                            required />
                                        <ridango-label>{{ 'MY_PROFILE_DEPARTMENT_NAME' | translate }}</ridango-label>
                                        <ridango-error *ngIf="departmentForm.controls.name.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="departmentForm.controls.contactName"
                                            ridangoInput
                                            name="department.contactName"
                                            required />
                                        <ridango-label>{{
                                            'MY_PROFILE_COMPANY_CONTACT_NAME' | translate
                                        }}</ridango-label>
                                        <ridango-error *ngIf="departmentForm.controls.contactName.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="departmentForm.controls.contactEmail"
                                            ridangoInput
                                            name="department.contactEmail"
                                            required />
                                        <ridango-label
                                            >{{ 'MY_PROFILE_COMPANY_CONTACT_EMAIL' | translate }}
                                        </ridango-label>
                                        <ridango-error
                                            *ngIf="departmentForm.controls.contactEmail.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                        <ridango-error *ngIf="departmentForm.controls.contactEmail.hasError('email')">
                                            {{ 'EMAIL_NOT_VALID' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="departmentForm.controls.contactPhone"
                                            ridangoInput
                                            name="department.contactPhone"
                                            required />
                                        <ridango-label
                                            >{{ 'MY_PROFILE_COMPANY_CONTACT_PHONE' | translate }}
                                        </ridango-label>
                                        <ridango-error
                                            *ngIf="departmentForm.controls.contactPhone.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__footer">
                                    <div class="edit-profile-account-items-area__right">
                                        <button class="btn btn--maximal btn--primary btn--big" type="submit">
                                            {{ 'SAVE_COMPANY_DETAILS' | translate }}
                                        </button>
                                    </div>

                                    <div class="edit-profile-account-items-area__left">
                                        <a class="link link--action link--emphasized" (click)="cancelAdd()">{{
                                            'CANCEL_COMPANY_ADDING' | translate
                                        }}</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
